import { Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import WSDateField from "../../Components/DateField/WSDateField";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSButton from "../../Components/Button/WSButton";
import { useNavigate, useParams } from "react-router-dom";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const BankAccount: React.FC<any> = React.memo((props) => {
      const { control, register, handleSubmit } = useForm();
          const [loading, setLoading] = useState(false);
           const params = useParams();
            const id = params?.id;
      
      const navigate = useNavigate()
    const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  
   const handleCancelClick = () => {
    navigate("/");
  };

    useEffect(() => {
      updateMainHeader("Bank Account");
    });
  
    breadCrumbsStore.updateBreadCrumbs([
      { "Bank Account List": "/Bank-account/list" },
      { [!id ? "Add Bank Account" : "Update Bank Account"]: "/Bank-account/create" },
    ]);
  return (
    <>
    <Grid p={3}>
        <Paper
          elevation={0}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            marginTop: 0,
            paddingBottom: 25,
            borderRadius: "8px",
          }}
        >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography fontWeight="bold" variant="h6">
            Add Bank Account
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
             <WSTextField
                label={"Account Display Name"}
                {...register("accountDisplayName")}
                id="accountDisplayName"
                name="accountDisplayName"
                control={control}
                rules={{ required: false }}
              />
        </Grid>
          <Grid item xs={12} sm={6}>
             <WSTextField
                label={"Opening Balance"}
                {...register("openingBalance")}
                id="openingBalance"
                name="openingBalance"
                control={control}
                rules={{ required: false }}
              />
        </Grid>
          <Grid item xs={12} sm={6}>
               <WSDateField
                id="asOfDate"
                name="asOfDate"
                label={" As Of Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
        </Grid>
         <Grid item xs={12}>
       <span style={{color:"blue"}}><WSIcons.AddIcon/> Add more fields</span>     
         </Grid>
         <Grid item xs={12} >
                       <WSSCheckBoxField
                         label="Print UPI QR Code on Invoices"
                         id="printUpiCode"
                         control={control}
                         {...register("printUpiCode")}
                         rules={{ required: false }}
                         name="printUpiCode"
                         
                       />
                     </Grid>
                      <Grid item xs={12} >
                       <WSSCheckBoxField
                         label="Print Bank Details on Invoices"
                         id="printBankDetails"
                         control={control}
                         {...register("printBankDetails")}
                         rules={{ required: false }}
                         name="printBankDetails"
                         
                       />
                     </Grid>
      </Grid>
      </Paper>
       <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
             <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
               
              />
          </Grid>

          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save Details"
              size="medium"
              variant="outlined"
              color="primary"
              loading={loading}
              onClick={handleSubmit(handleData)}
              sx={{
                borderRadius: 2,
                border: "1px solid rgba(126, 176, 246, 1)",
                color: "#FFFFFF",
                backgroundColor: "rgba(126, 176, 246, 1)",
                "&:hover": {
                  backgroundColor: "rgba(126, 176, 246, 1)",
                },
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
